/**
 * UpdateAvailableModal — French copy constants (i18n-ready).
 *
 * Each state of the modal has its own text payload. The component renders
 * the body as React nodes so we can embed the <span> the mockup uses for the
 * highlighted substring — we model that here with bodyLead/bodyHighlight/bodyTail.
 *
 * Source of truth: .superpowers/brainstorm/35077-1775930510/content/update-modal-v11.html
 */

export interface UpdateModalCopy {
  title: string
  metaTime: string
  bodyLead: string
  bodyHighlight: string
  bodyTail: string
  cta: string
  helper: string
}

export const UPDATE_MODAL_COPY: {
  default: UpdateModalCopy
  deferred: UpdateModalCopy
  reloading: UpdateModalCopy
  success: { title: string }
} = {
  default: {
    title: 'Nouvelle version disponible',
    metaTime: "à l'instant",
    bodyLead: 'Rechargez pour obtenir les ',
    bodyHighlight: 'dernières améliorations',
    bodyTail: ' et corrections de bugs.',
    cta: 'Recharger maintenant',
    helper: 'Vos analyses et votre session sont conservées',
  },
  deferred: {
    title: 'Nouvelle version disponible',
    metaTime: 'en attente',
    bodyLead: 'Votre ',
    bodyHighlight: 'analyse Approfondi en cours',
    bodyTail: ' sera préservée. Mise à jour proposée dès qu\'elle sera terminée.',
    cta: 'En attente de votre analyse\u2026',
    helper: "Aucune action requise pour l'instant",
  },
  reloading: {
    title: 'Mise à jour en cours\u2026',
    metaTime: 'rechargement',
    bodyLead: 'Application des dernières améliorations. ',
    bodyHighlight: 'Dans une seconde',
    bodyTail: '.',
    cta: 'Rechargement\u2026',
    helper: 'Chargement de la nouvelle version',
  },
  success: {
    title: 'Vous êtes à jour',
  },
}

/** Default version string shown in meta when the new version is unknown. */
export const FALLBACK_VERSION_LABEL = 'nouvelle version'
